export default __webpack_public_path__ + "static/viseca-thumbnail-8a7f4b1d821e7dfe9558bb7a9a640c55.webp";